import { setCookie, getCookie } from './cookie';
const  { getFingerPrintId } = require('./fingerprint');

class ScTrack {
    static instance = null;

    constructor() {
        this.trackInstance = null;
        this.fingerprintId = '';

        this._initPromise = null;
        this._scriptPromise = null;
        this._queue = [];
        this._isFlushing = false;
        this._retryTimer = null;
        this._retryCount = 0;
        this._maxRetries = 5;

        this.init();
    }

    static getInstance(options = {}) {
        if (!ScTrack.instance) {
            ScTrack.instance = new ScTrack(options);
        }
        return ScTrack.instance;
    }

    async getComputerId() {
        this.fingerprintId = await getFingerPrintId();
    }


    loadSdk() {
        return this._ensureSdkLoaded();
    }

    _ensureSdkLoaded() {
        const JFTrack = typeof window !== 'undefined' ? window.jftrack : undefined;
        if (typeof JFTrack !== 'undefined') return Promise.resolve(true);
        if (this._scriptPromise) return this._scriptPromise;

        this._scriptPromise = new Promise((resolve) => {
            try {
                const ele = document.createElement('script');
                ele.src = 'https://upload.chongnengjihua.com/production/jfnpm/sa-track/1.0.3/jftrack.min.js';
                ele.async = true;
                ele.onload = () => {
                    resolve(true);
                };
                ele.onerror = () => {
                    this._scriptPromise = null;
                    resolve(false);
                };
                document.body.appendChild(ele);
            } catch (e) {
                this._scriptPromise = null;
                resolve(false);
            }
        });
        return this._scriptPromise;
    }

    async init() {
        if (this._initPromise) return this._initPromise;
        this._initPromise = (async () => {
            try {
                await this._ensureSdkLoaded();
                await this.getComputerId();
                const JFTrack = typeof window !== 'undefined' ? window.jftrack : undefined;
                if (typeof JFTrack === 'undefined') {
                    this._initPromise = null;
                    return;
                }
                this.trackInstance = new JFTrack({
                    debugger: process.env.NODE_ENV !== 'production',
                    server_url: 'https://jc-sensors.9fapi.com/sa',
                    userName: this.fingerprintId || '9fztgw',
                    platForm: '9fztgw',
                    project:
                        process.env.NODE_ENV !== 'production'
                            ? 'rjhy_huntianling_test'
                            : 'ytx_xinlanghuixuangu',
                });
            } catch (e) {
                this._initPromise = null;
            }
        })();
        return this._initPromise;
    }

    async _flushQueue() {
        if (this._isFlushing) return;
        this._isFlushing = true;
        try {
            await this.init();
            if (!this.trackInstance) {
                if (this._queue.length > 0 && !this._retryTimer && this._retryCount < this._maxRetries) {
                    this._retryCount++;
                    this._retryTimer = setTimeout(() => {
                        this._retryTimer = null;
                        this._flushQueue();
                    }, 500);
                }
                return;
            }
            this._retryCount = 0;
            while (this._queue.length > 0) {
                const item = this._queue.shift();
                if (!item) continue;
                this.trackInstance.track(item.eventName, item.props);
            }
        } finally {
            this._isFlushing = false;
        }
    }

    track(eventName, props = {}) {
        const mergedProps = Object.assign(
            {
                server_id: 200,
                platform_id: '9fztgw',
                front_type: 'wap',
                project_id: 'ytx_jfztgw',
                computer_id: this.fingerprintId,
            },
            props,
        );
        this._queue.push({ eventName, props: mergedProps });
        this._flushQueue();
    }

    // getFingerprintId() {
    //     let fingerprintId = getCookie('fingerprintId');
    //     if (!fingerprintId) {
    //         fingerprintId = +new Date() + randomString(4);
    //     }
    //     setCookie('fingerprintId', fingerprintId, 7);
    //     this.fingerprintId = fingerprintId;
    // }
}

export default ScTrack;
